import {auth} from 'configs/firebase'
import {useAuthState as useFirebaseAuthHook} from 'react-firebase-hooks/auth'

export default function useAuthState() {
  return useFirebaseAuthHook(auth)
}
